export default {
  methods: {
    /* storeからページ共通のCSSの値を取り出す */
    findPageCss (selector, prop) {
      return this.$store.getters.findPageStyle(selector, prop)
    },
    /* storeからページ共通のCSSの値を削除する */
    deletePageCss ({ selector, prop }) {
      this.$store.commit('deletePageCssProp', {
        selector: selector,
        prop: prop,
      })
    },
    closeButton () {
      // パレットのカラーピッカーが開かれていたら閉じる
      if (this.$store.getters.getStatusColorPicker.pane === 'palette') {
        this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: null })
        this.$store.commit('updateStatusColorPicker', { prop: 'selector', value: null })
        this.$store.commit('updateStatusColorPicker', { prop: 'prop', value: null })
      }
      this.$emit('close')
    }
  }
}
